
import ReactApexChart from 'react-apexcharts';
export const lineChart = (series,y="Orders",stroke="smooth",type=1) =>{
  let dataLabel=[0,1,2]
  if(type==2){
    dataLabel=[0]
  }
     const options= {
      chart: {
        height: 350,
        type: 'line',
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: false
        }
      },
      colors: ['#C0031B', '#545454','#0860FA'],
      dataLabels: {
         enabled: true,
        enabledOnSeries: dataLabel
      },
      stroke: {
        curve: stroke
      },
     
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      markers: {
        size: 1
      },
      xaxis: {
        categories: series[0].x,
        title: {
          text: 'Month'
        }
      },
      yaxis: {
        title: {
          text:y
        },
        
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        floating: true,
        offsetY: 2,
        offsetX: -5
      }
    }
     return (
       <div>
          <ReactApexChart options={options} series={series} type="line" height  ={400} />
       </div>
     )

  }